<div id="login" class="learnspace-theme">
  <div id="login-form-wrapper" fxLayout="column" fxLayoutAlign="center center">
    <div class="stepper-container">
      <mat-horizontal-stepper [linear]="true" #stepper>
        <mat-step>
          <div class="step1">
            <div class="logo">
              <img src="assets/wonda/wonda-gradient.svg">
            </div>
            <div class="title">Create your account </div>
            <div class="password-login">
              <form name="signUpForm" [formGroup]="signUpForm" novalidate>
                <mat-form-field>
                  <input matInput placeholder="Full Name" formControlName="first_name">
                  <mat-error *ngIf="signUpForm.get('first_name').hasError('required')">
                    Full Name is required
                  </mat-error>
                </mat-form-field>
                <mat-form-field>
                  <input matInput placeholder="Email" formControlName="email">
                  <mat-error *ngIf="signUpForm.get('email').hasError('required')">
                    Email is required
                  </mat-error>
                  <mat-error *ngIf="!signUpForm.get('email').hasError('required') &&
                                signUpForm.get('email').hasError('email')">
                    Please enter a valid email address
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <input matInput type="password" placeholder="Password" formControlName="password">
                  <mat-error>
                    Password is required
                  </mat-error>
                </mat-form-field>
              </form>
              <div *ngIf="signUpError" style="color:red;">{{ signUpError}}</div>
              <button mat-raised-button color="primary" class="submit-button" aria-label="LOG IN"
                [disabled]="signUpForm.invalid" (click)="createUser()">
                CREATE ACCOUNT
              </button>
            </div>
            <div class="light-text">OR</div>
            <div class="other-login">
              <button mat-stroked-button color="primary" (click)="quickLogin('google')">
                <img src="assets/svg/google-blue-logo.svg">
                SIGN UP WITH GOOGLE
              </button>
              <button mat-stroked-button color="primary" (click)="quickLogin('microsoft')">
                <img src="assets/svg/microsoft-blue-logo.svg">
                SIGN UP WITH MICROSOFT
              </button>
              <button (click)="ssoFlow(stepper)" mat-stroked-button color="primary">
                <img src="assets/svg/sso-blue-logo.svg">
                SIGN UP WITH SSO
              </button>
            </div>
            <div class="other-links">
              <div class="light-text">EXISTING ACCOUNT?</div>
              <button mat-stroked-button color="primary" [routerLink]="['/login']">
                LOGIN
              </button>
            </div>
          </div>
        </mat-step>
        <mat-step>
          <search-hub-by-domain [isSignUp]="true"></search-hub-by-domain>
        </mat-step>
      </mat-horizontal-stepper>
    </div>
  </div>
</div>